import backend from '../index'

export default async function getSchools() {
  const schools = await backend.get(`/schools`)
  return schools.data
}

export async function getSchool(schoolId) {
  const school = await backend.get(`/schools/${schoolId}`)
  return school.data
}
